import * as types from '@/store/types';
import service from '@/api/SeaService'

export default {
    [types.ACTION_ADD_SEA]: ({commit}, payload) => {
        service.addSea(payload)
    },
    [types.ACTION_UPDATE_SEA]: ({commit}, payload) => {
        service.updateSea(payload)
    }    
}


// WEBPACK FOOTER //
// ./src/store/modules/sea/actions.js